module.exports = __webpack_public_path__ + "img/logo.50474800.png";